import API from '../../helpers/API';
import { SHOW_LOADER, HIDE_LOADER, SET_MENU_ITMES, SET_HOME_DATA } from '../../common/constants/ActionTypes';
import { OTPS, GET_MENU_ITEMS, GET_HOME_DATA } from '../../common/constants/endpoints';
import { toastr } from 'react-redux-toastr';
import CryptoJS from 'crypto-js';
import CRC32 from 'crc-32';
const SECRET_KEY = "S300cr3t!@#Key$%^&*()_+[]{}|;':,.<>?/~`";

export function generateCRC(config) {
    // const dataWithSecret = SECRET_KEY
    // const localCrcValue = CRC32.str(dataWithSecret).toString(16);
    // return localCrcValue
    if(config && config.data){
        const secretKey = SECRET_KEY; 
        const requestBody = config.data ? JSON.stringify(config.data) : '';
        const dataWithSecret = encryptData(requestBody) + secretKey;
        const crcValue  = CRC32.str(dataWithSecret);
        const unAssignCRCValue = (crcValue >>> 0).toString(16)
        return unAssignCRCValue;

    }else{
        const dataWithSecret = SECRET_KEY
        const localCrcValue = CRC32.str(dataWithSecret).toString(16);
        return localCrcValue
    }
    

}
const decryptKey = CryptoJS.enc.Utf8.parse('1234567812345678');
const decryptIV = CryptoJS.enc.Utf8.parse('1234567812345678');
export function encryptData(data) {
    try {
        const encrypted = CryptoJS.AES.encrypt(data, decryptKey, {
            iv: decryptIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    } catch (error) {
        console.error("Encryption failed:", error);
        return null;
    }
}

export function decryptData(encryptedData) {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, decryptKey, {
            iv: decryptIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
}

export const generateCaptcha = () => {

    return async (dispatch) => {
        dispatch(showLoader());
        try {

            let response = await API.post(OTPS, {
                "type": "captcha"
            });
            if(response!=null)
            {
                dispatch(hideLoader());
            }
        } catch (error) {
            dispatch(hideLoader());
            toastr.error("Error while generating the captcha image:", error.message);
        }
    }

};

export const showLoader = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOADER
        })
    }
};

export const hideLoader = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOADER
        })
    }
};

export const getMenuItems = () => {
    
    return async function (dispatch) {
        let response;
        try {
            response = await API.get(GET_MENU_ITEMS, {
              
            });
            if(response!=null)
            {
                // dispatch(hideLoader());
            }
            dispatch({
                type: SET_MENU_ITMES,
                payload: response.data,
            });

        } catch (error) {
            // dispatch(hideLoader());
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getHomePageData = () => {
    
    return async function (dispatch) {
        dispatch(showLoader());
        let response;
        try {
            response = await API.get(GET_HOME_DATA, {
               
            });
            if(response!=null)
            {
                // dispatch(hideLoader());
            }
            dispatch({
                type: SET_HOME_DATA,
                payload: response.data,
            });

        } catch (error) {
            // dispatch(hideLoader());
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
